import type { CardInfo } from '@lub0v/santa-utils';
import type { BadgeTone } from '@src/components';

/**
 * How far one participant has got, from the organizer's point of view. The
 * order of the checks is the order of the journey, so the badge always shows
 * the furthest point reached: a card that has been opened says so even though
 * an email was sent to get there.
 *
 * Copying a personal link leaves no trace on the server — there is nothing to
 * record that the organizer put it on their clipboard — so that state is kept
 * in the browser for this game (see linkInviteStorage).
 */
export type ParticipantStatus =
  | 'not_sent'
  | 'invite_link'
  | 'invite_email'
  | 'card_opened'
  | 'ward_received';

export function participantStatus(card: CardInfo, copiedIds: Set<number>): ParticipantStatus {
  if (card.isWardKnown) {
    return 'ward_received';
  }
  if (card.isVerified) {
    return 'card_opened';
  }
  if (card.email) {
    return 'invite_email';
  }
  if (copiedIds.has(card.id)) {
    return 'invite_link';
  }
  return 'not_sent';
}

export function participantStatusTone(status: ParticipantStatus): BadgeTone {
  if (status === 'ward_received') {
    return 'success';
  }
  if (status === 'invite_email' || status === 'invite_link' || status === 'card_opened') {
    return 'info';
  }
  return 'neutral';
}
